export default __webpack_public_path__ + "static/media/avatar-agent-default.51f83395.svg";